import React, { useMemo } from 'react';

import { Outlet } from 'react-router-dom';

import ContactsNavigationPanelContainer from '@pages/organizer/Contacts/components/ContactsNavigationPanelContainer';
import { useInitContacts } from '@pages/organizer/Contacts/hooks/use-init-contacts';

const ContactsOutletContainer = () => {
  const { selectUserInfo, isTabletDisplay } = useInitContacts();

  const navigationPanel = <ContactsNavigationPanelContainer />;
  const panelWithSelectInfo = useMemo(() => {
    return selectUserInfo ? null : <ContactsNavigationPanelContainer />;
  }, [selectUserInfo]);

  return (
    <>
      {isTabletDisplay ? panelWithSelectInfo : navigationPanel}

      <Outlet />
    </>
  );
};

export default ContactsOutletContainer;
